<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pYQusU/image/1.png?1685790608499" alt="This image is the cover for the book True Love"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">True Love
      </h1>
      <p class="bookDescription body article font2">
        <p>Uriel has a lot of questions about life and is determined to know the answers. Through inquiry, exploration, chance, experience and realization, all of these questions are answered over a lifetime of truly living. Join Uriel as he uncovers and awakens to the true meaning of life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joshua Lewan
      </h2>
      
      <p class="authorDescription body article">Joshua Lewan is from Byron Bay and lives in Mullumbimby, Australia. He was clinically diagnosed with Asperger Syndrome on the Autism Spectrum and is an advocate for neurodiversity, freedom/freedom of speech, spirituality/consciousness, unconditional love and natural health/medicines. <br>Josh finished a diploma in Shamanism, has studied Traditional Chinese Medicine Remedial Massage Therapy and also has a diploma in Intuitive Spiritual Healing. He has worked as a healer for several years and is a music artist.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?26a5c3d4